import type { RunSchema } from '@/types/schema';

export const getRegressionScore = (
  runs: RunSchema[],
  regressionsFilterFeedbackKey?: string | null
) => {
  if (regressionsFilterFeedbackKey == null) {
    return undefined;
  }
  const runsWithScore = runs?.filter(
    (run) =>
      typeof run.feedback_stats?.[regressionsFilterFeedbackKey]?.avg ===
        'number' &&
      typeof run.feedback_stats?.[regressionsFilterFeedbackKey]?.n ===
        'number' &&
      run.feedback_stats?.[regressionsFilterFeedbackKey]?.n >= 1
  );
  if (!runsWithScore?.length) {
    return undefined;
  }
  const totalRunsWithScore = runsWithScore.reduce(
    (acc, run) =>
      acc + (run.feedback_stats?.[regressionsFilterFeedbackKey]?.n ?? 0),
    0
  );
  return (
    runsWithScore.reduce(
      (acc, run) =>
        acc +
        (run.feedback_stats?.[regressionsFilterFeedbackKey]?.avg ?? 0) *
          (run.feedback_stats?.[regressionsFilterFeedbackKey]?.n ?? 0),
      0
    ) / totalRunsWithScore
  );
};
